import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import * as logger from 'universal-logger';
import { decorateWith } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import * as ObjectUtil from 'helpers/object';
import { isAbsent, isEmpty } from 'helpers/verify';
import Base64Deriver from 'derivers/Base64';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { withSagas } from 'decorators/Sagas';
import { selectMsaId } from 'redux/modules/features/homepage';
import { selectUserDetectedLocation, selectUserSelectedLocation } from 'redux/modules/locale';
import { msas, promotionByAlias } from 'redux/saga/entities/bound';
import { selectGlsLocationFromCoordinates } from 'redux/saga/selectors/gls';
import { msaByIdentifier } from 'redux/saga/selectors/msas';
import { ProductGroup } from './ProductGroup';
import { loadSaga, watchSaga, loadCardData, PRODUCT_GROUP_DISCLAIMER_TYPES, PRODUCT_TYPES } from './ProductGroup.saga';
var messages = defineMessages({
  ctaSelect: {
    id: 'product-card.card.cta.select',
    defaultMessage: 'Select'
  },
  disclaimerAutoRenewal: {
    id: 'product-card.disclaimer.autoRenewal',
    defaultMessage: 'After your free trial, you’ll auto-enroll in our {price}/month plan. Change or cancel any time during your trial to not be charged.'
  },
  firstMonthOfferNote: {
    id: 'product-card.card.first-month-offer-note',
    defaultMessage: '~~{recurringPrice}~~ first month'
  },
  planDetails: {
    id: 'product-card.card.plan-details',
    defaultMessage: 'Includes __{creditsPerCycle, number}&nbsp;credits__ to book __{minClassEstimate, number}&nbsp;-&nbsp;{maxClassEstimate, number}&nbsp;classes__'
  }
});

function formatPrice(intl, msa, price, withFractionDigits) {
  return intl.formatNumber(Math.max(0, price), _objectSpread({
    style: 'currency',
    currency: msa.currency_code
  }, !withFractionDigits && {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  }));
}

function formatPlanDetails(intl, plan) {
  var creditsPerCycle = plan.credits_per_cycle,
      maxClassEstimate = plan.max_class_estimate,
      minClassEstimate = plan.min_class_estimate;

  if ([creditsPerCycle, maxClassEstimate, minClassEstimate].some(isAbsent)) {
    logger.warn("Incomplete plan data for plan [".concat(plan.id, "]"));
    return '';
  } // NOTE: non-breaking elements to ensure proper formatting


  return intl.formatMessage(messages.planDetails, {
    creditsPerCycle: creditsPerCycle,
    minClassEstimate: minClassEstimate,
    maxClassEstimate: maxClassEstimate
  });
}

var mapCustomCard = function mapCustomCard(state, props) {
  return ObjectUtil.pick(['callout', 'calloutNote', 'ctaCopy', 'details', 'disclaimer', 'modules', 'tag', 'url'], props);
};

var mapPromoCard = function mapPromoCard(state, props) {
  var callout = props.callout,
      calloutNote = props.calloutNote,
      cardType = props.cardType,
      ctaCopy = props.ctaCopy,
      details = props.details,
      disclaimer = props.disclaimer,
      disclaimerType = props.disclaimerType,
      intl = props.intl,
      modules = props.modules,
      productCode = props.productCode,
      tag = props.tag;
  var msa = msaByIdentifier(msas.data(state), selectMsaId(state)) || {};

  if (isEmpty(msa)) {
    return {};
  }

  var key = promotionByAlias.defaultKey(null, productCode, msa.id);
  var promotion = promotionByAlias.data(state, key) || {}; // TODO: make sure offers is never even populated with null entries

  var offers = (promotion.offers || []).filter(Boolean);
  var cards = offers.map(function (offer) {
    var initialPrice = formatPrice(intl, msa, offer.price);
    var recurringPrice = formatPrice(intl, msa, offer.recurring_plan.price);
    var isSingleMonth = offer.initial_duration_formatted === '1 month'; // Note: backwards compatabile for non-required price terms

    var note = deepExtract('content.card.price_terms', offer) || isSingleMonth && intl.formatMessage(messages.firstMonthOfferNote, {
      recurringPrice: recurringPrice
    }) || '';
    var disclaimerNote = disclaimerType === PRODUCT_GROUP_DISCLAIMER_TYPES.autoRenewal ? intl.formatMessage(messages.disclaimerAutoRenewal, {
      price: formatPrice(intl, msa, offer.recurring_plan.price, true)
    }) : ''; // NOTE: variables need to match Contentful conventions
    // TODO: deal with internationalized durations

    var contextVariables = {
      initial_plan: {
        class_estimate_min: deepExtract('initial_plan.min_class_estimate', offer),
        class_estimate_max: deepExtract('initial_plan.max_class_estimate', offer),
        credits: deepExtract('initial_plan.credits_per_cycle', offer),
        duration: deepExtract('initial_duration_formatted', offer),
        price: initialPrice
      },
      recurring_plan: {
        class_estimate_min: deepExtract('recurring_plan.min_class_estimate', offer),
        class_estimate_max: deepExtract('recurring_plan.max_class_estimate', offer),
        credits: deepExtract('recurring_plan.credits_per_cycle', offer),
        duration: '1 month',
        price: recurringPrice
      }
    };
    var url = cardType.toLowerCase() === 'signupcard' ? "/verify-phone/offer/".concat(Base64Deriver.encode(offer.id)) : "/signup/offer/".concat(Base64Deriver.encode(offer.id));
    return {
      callout: initialPrice,
      calloutNote: note,
      contextVariables: contextVariables,
      cta: deepExtract('content.card.cta_copy', offer) || intl.formatMessage(messages.ctaSelect),
      details: formatPlanDetails(intl, offer.initial_plan),
      disclaimer: disclaimerNote,
      productId: offer.id,
      productType: 'offer',
      tag: deepExtract('content.card.tag', offer, ''),
      url: url
    };
  });

  if (isEmpty(cards)) {
    return {};
  }

  var _cards = _slicedToArray(cards, 1),
      card = _cards[0];

  return {
    callout: callout || card.callout,
    calloutNote: calloutNote || card.calloutNote,
    contextVariables: card.contextVariables,
    ctaCopy: ctaCopy || card.cta,
    details: details || card.details,
    disclaimer: disclaimer || card.disclaimer,
    modules: modules,
    productId: card.productId,
    productType: card.productType,
    tag: tag || card.tag,
    url: props.url || card.url
  };
};

export var isSupportedLocation = function isSupportedLocation(state) {
  var pathMsaId = selectMsaId(state);
  var pathMsa = msaByIdentifier(msas.data(state), pathMsaId) || {};
  var detectedLocation = selectGlsLocationFromCoordinates(state, selectUserDetectedLocation(state));
  var selectedLocation = selectGlsLocationFromCoordinates(state, selectUserSelectedLocation(state)); // Find the country of all set locations

  var countryCodes = [!isEmpty(detectedLocation) && deepExtract('msa.country.code', detectedLocation, 'UNKNOWN'), !isEmpty(selectedLocation) && deepExtract('msa.country.code', selectedLocation, 'UNKNOWN'), pathMsa.country_code].filter(Boolean);
  return !isEmpty(countryCodes) && countryCodes.every(function (code) {
    return code === 'USA';
  });
}; // NOTE: Browser detection is tricky.  Full detection support should use a library

export var isSupportedBrowser = function isSupportedBrowser(state) {
  var userAgent = deepExtract('request.userAgent', state, '');
  return !/\b(?:MSIE|Trident)\b/.test(userAgent);
};
export var mapStateToProps = function mapStateToProps(state, props) {
  // NOTE: restrict new behavior to US-only until we resolve international support
  var cardType = isSupportedBrowser(state) && isSupportedLocation(state) && props.cardType || 'ProductCard';
  var card;
  var productType = props.productType;

  switch (productType) {
    case PRODUCT_TYPES.promotion:
      card = mapPromoCard(state, _objectSpread({}, props, {
        cardType: cardType
      }));
      break;

    case PRODUCT_TYPES.custom:
    default:
      // do nothing since the component will just use all the props
      // from the module to populate the UI
      card = mapCustomCard(state, props);
  } // TODO: Build the disclaimer separately from the rest of the card


  var disclaimer = card.disclaimer;
  delete card.disclaimer;
  return {
    card: card,
    cardType: cardType,
    disclaimer: disclaimer,
    msaId: selectMsaId(state)
  };
};
export var mapDispatchToProps = {
  loadCardData: loadCardData
};
export var ProductGroupContainer = decorateWith(trackDwell, withSagas({
  load: loadSaga,
  watch: watchSaga
}), connect(mapStateToProps, mapDispatchToProps), injectIntl)(ProductGroup);
ProductGroupContainer.propTypes = _objectSpread({}, ProductGroup.propTypes, {
  intl: intlShape.isRequired,
  disclaimerType: PropTypes.oneOf(Object.values(PRODUCT_GROUP_DISCLAIMER_TYPES)),
  productType: PropTypes.oneOf(Object.values(PRODUCT_TYPES)),
  productCode: PropTypes.string
});